import { normalizeItems } from "../../helpers/CoreHelpers";

const initialState = {
    items: [],
    menu: [],
    single: {},
    type: null,
    loading: true,
    refresh: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'HIDE_SUB_BAR':
            return {
                ...state,
                single: {}
            };
        case 'MENU_SINGLE_SUCCESS':
            return {
                ...state,
                single: action.payload.data
            };
        case 'MENU_STOP_GET':
            return {
                ...state,
                loading: false
            };
        case 'MENU_START_GET':
            return {
                ...state,
                loading: action.payload.type !== state.type,
                type: action.payload.type
            };
        case 'MENU_GET_SUCCESS':
            return {
                ...state,
                type: action.payload.type,
                items: action.payload.data,
                menu: normalizeItems(action.payload.data),
                loading: false
            };
        case 'MENU_REFRESH_TRUE':
            return {
                ...state,
                refresh: true
            };
        case 'MENU_REFRESH_FALSE':
            return {
                ...state,
                refresh: false
            };
        case 'MENUS':
            return initialState;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/core/store/reducers/menu.js